import { render } from "./TrabajosRealizadosOperario.vue?vue&type=template&id=2cba7ef0&scoped=true"
import script from "./TrabajosRealizadosOperario.vue?vue&type=script&lang=js"
export * from "./TrabajosRealizadosOperario.vue?vue&type=script&lang=js"

import "./TrabajosRealizadosOperario.vue?vue&type=style&index=0&id=2cba7ef0&scoped=true&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cba7ef0"]])

export default __exports__